import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// signInWithRedirect only works when authDomain matches the page's origin:
// browsers partition cross-site storage, so a handler hosted on a different
// domain can't hand the pending result back (sign-in silently no-ops).
// Firebase Hosting serves /__/auth/* on every connected custom domain, so we
// use the current host as authDomain in the browser. localhost keeps the
// env-configured domain (no /__/auth handler is served by `next dev`).
const authDomain =
  typeof window !== "undefined" && window.location.hostname !== "localhost"
    ? window.location.hostname
    : process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN;

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const auth = getAuth(app);
